import React, { useRef } from "react";
import {
  Button,
  CircularProgress,
  FormHelperText,
  Stack,
  TextField,
} from "@mui/material";

const OtpForm = ({
  email,
  otpArray,
  setOtpArray,
  otp,
  setOtp,
  formErrors,
  handleSubmitOTP,
  submittingOTP,
  canResend,
  timer,
  handleResendOTP,
  setGetOtp,
  appName,
}) => {
  const otpFields = useRef([]);

  const handleOtpChange = (index, event) => {
    const { value } = event.target;
    if (!/^\d?$/.test(value)) {
      return;
    }

    const nextOtpArray = [...otpArray];
    nextOtpArray[index] = value;
    setOtpArray(nextOtpArray);
    setOtp(nextOtpArray.join(""));

    if (value && index < otpArray.length - 1) {
      otpFields.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otpArray[index] && index > 0) {
      otpFields.current[index - 1]?.focus();
    }
    if (event.key === "Enter") {
      handleSubmitOTP();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pasted = event.clipboardData.getData("text").trim();
    if (!/^\d{6}$/.test(pasted)) {
      return;
    }
    const nextOtpArray = pasted.split("");
    setOtpArray(nextOtpArray);
    setOtp(pasted);
  };

  return (
    <div className="ax-sso-form">
      <header className="ax-sso-form-head">
        <h1>Verify it&rsquo;s you</h1>
        <p>
          Enter the 6-digit code sent to <strong>{email}</strong>
          {appName ? ` to continue to ${appName}.` : "."}
        </p>
      </header>

      <Stack spacing={2}>
        <div className="ax-sso-otp" onPaste={handlePaste}>
          {otpArray.map((digit, index) => (
            <TextField
              key={index}
              inputRef={(node) => {
                otpFields.current[index] = node;
              }}
              value={digit}
              onChange={(event) => handleOtpChange(index, event)}
              onKeyDown={(event) => handleKeyDown(index, event)}
              autoFocus={index === 0}
              inputProps={{
                maxLength: 1,
                inputMode: "numeric",
                "aria-label": `Digit ${index + 1}`,
                style: {
                  textAlign: "center",
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  padding: "14px 0",
                },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  backgroundColor: "var(--ax-surface)",
                },
              }}
            />
          ))}
        </div>

        <FormHelperText
          error
          sx={{ minHeight: "1.2em", textAlign: "center", margin: 0 }}
        >
          {formErrors.otp || " "}
        </FormHelperText>

        <Button
          fullWidth
          variant="contained"
          disabled={otp.length !== 6 || submittingOTP}
          onClick={handleSubmitOTP}
          aria-label="Continue with AuthX"
          sx={{
            height: 50,
            borderRadius: "10px",
            backgroundColor: "var(--ax-blue)",
            fontSize: "0.95rem",
            fontWeight: 600,
            letterSpacing: "-0.005em",
            "&:hover": {
              backgroundColor: "var(--ax-blue-hover)",
            },
          }}
        >
          {submittingOTP ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            "Continue with AuthX"
          )}
        </Button>

        <div className="ax-sso-otp-meta">
          <button
            type="button"
            className="ax-sso-link"
            onClick={() => {
              setGetOtp(false);
              setOtp("");
              setOtpArray(new Array(6).fill(""));
            }}
          >
            Use a different email
          </button>
          {canResend ? (
            <button
              type="button"
              className="ax-sso-link"
              onClick={handleResendOTP}
            >
              Resend code
            </button>
          ) : (
            <span className="ax-sso-muted">Resend in {timer}s</span>
          )}
        </div>
      </Stack>
    </div>
  );
};

export default OtpForm;
